import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {UserLoggedInComponent} from './user-logged-in.component';
import {TranslateModule} from '@xref/ngx';
import {HeaderModule} from "../header/header.module";
import {FooterModule} from "../footer/footer.module";
import {ButtonModule, InputsModule} from "@xref/xref-lib";
import {FormsModule} from "@angular/forms";

@NgModule({
    declarations: [UserLoggedInComponent],
    imports: [
        CommonModule,
        TranslateModule,
        HeaderModule, FooterModule,
        InputsModule,
        FormsModule,
        ButtonModule
    ],
    exports: [UserLoggedInComponent]
})
export class UserLoggedInModule {
}
